import { render, staticRenderFns } from "./edit-basic-info.vue?vue&type=template&id=38a9cdde&"
import script from "./edit-basic-info.vue?vue&type=script&lang=tsx&"
export * from "./edit-basic-info.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports